import { autos } from './role'

export const queries = {
  autos,
}
export default queries
